module.exports = __webpack_public_path__ + "static/img/zhuanli-4.194ecb60.png";